import React from 'react'
import imgcoming from "../../images/DIP.png"
export default function Comingsoonpage() {
  return (
    <div className='comingsoon'>
    <img src={imgcoming} alt='' />
    </div>
  )
}
